// extracted by mini-css-extract-plugin
module.exports = {"appear":"animationTitle_appear__2x6M5","appearActive":"animationTitle_appearActive__3wh4K"};